namespace Matrix.Workflow {
    export interface ClientFunctionInvokeRequest extends Serenity.ServiceRequest {
        FunctionName?: string;
        InvocationId?: number;
        Params?: { [key: string]: any };
        ParamTypes?: { [key: string]: string };
        ConfirmPending?: boolean;
        WorkflowInstanceId?: number;
        InvokedBy?: string;
        CurrentAction?: string;
    }
}
